module.exports = __webpack_public_path__ + "static/media/0-7.9d51bf82.svg";